import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { BookingDetails } from '../../../pages/dashBoardPage/interface';

// Register chart components
ChartJS.register(ArcElement, Tooltip, Legend);
const PieChart = ({ status }: { status: BookingDetails }) => {
  const data = {
    labels: ['Pending', 'Canceled', 'Confirmed'],
    datasets: [
      {
        label: 'Count',
        data: [
          status?.statusCounts?.PENDING,
          status?.statusCounts?.CANCELED,
          status?.statusCounts?.CONFIRMED,
        ],
        backgroundColor: ['#FFC62B', '#EB6F70', '#6BC497'],
        borderColor: ['#fff'],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: '60%', // Controls doughnut thickness
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return <Doughnut data={data} options={options} width={200} height={200} />;
};

export default PieChart;
